import { IconLoadingSpinner } from '@zoom/icons-react'
import useLightModePreference from '../util/useLightModePreference'
import '@zoom/icons-react/es/index.css'

const TextToImageSpinner = () => {
  const color = useLightModePreference()
    ? 'rgba(0, 0, 1, 1)'
    : 'rgba(255, 255, 255, 1)'

  return (
    <div>
      <IconLoadingSpinner
        style={{
          fontSize: '28px',
          color,
        }}
        animation="spin"
      />
    </div>
  )
}

export default TextToImageSpinner
